export const websiteImportsPollingInterval = 3000;
